module.exports = "/wp-content/plugins/farmacy/assets/js/images/bag-empty-fill-product-52d93d63d21ae5cd1efbe16cf8481021.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/cart/cart-empty/img/bag-empty-fill-product.png
 ** module id = 803
 ** module chunks = 1 9 157
 **/